import {
  CompaniesInfiniteSelectField,
  DetailsButton,
  FloatingFormItem,
  InfiniteTable,
} from '@/components/_common';
import { useStockItems } from '@/core/domain/stock/StockItems/StockItems.hooks';
import {
  ListStockItemsQuery,
  StockItem,
  StockItemType,
} from '@/core/domain/stock/StockItems/StockItems.types';
import { Col, Form, Row } from 'antd';
import { ColumnsType } from 'antd/es/table/interface';
import { useIntl } from 'react-intl';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useState } from 'react';
import { getTableScrollX } from '@/utils/table';
import formatterPrice from '@/utils/number/formatterPrice';
import { flatInfiniteResult } from '@/utils/request/flatInfiniteResult';

const SearchPartReplacementTable = () => {
  const intl = useIntl().formatMessage;
  const history = useHistory();

  const { partId } = useRouteMatch<{ partId: string }>().params;

  const [queryParams, setQueryParams] = useState<ListStockItemsQuery>({
    partReplacement: +partId,
    itemType: StockItemType.Part,
    active: true,
  });

  const stockItemsList = useStockItems(true, queryParams);

  const stockItems = flatInfiniteResult(stockItemsList.data);

  const columns: ColumnsType<StockItem> = [
    {
      title: intl({ id: 'parts.consultation.application.internalCode' }),
      dataIndex: 'sku',
      key: 'sku',
      width: 120,
    },
    {
      title: intl({ id: 'parts.consultation.application.manufacturerCode' }),
      dataIndex: 'manufacturingCode',
      key: 'manufacturingCode',
      width: 120,
    },
    {
      title: intl({ id: 'parts.consultation.application.description' }),
      dataIndex: 'description',
      key: 'description',
      width: 180,
    },
    {
      title: intl({ id: 'parts.consultation.application.localization' }),
      dataIndex: 'location',
      key: 'location',
      render: (value) => value || '-',
      width: 180,
    },
    {
      title: intl({ id: 'parts.consultation.application.stock' }),
      dataIndex: 'stock',
      key: 'stock',
      render(_, row) {
        const stockItem = row.stock.find(
          (item) =>
            queryParams.companiesIds?.length &&
            item.company.id === Number(queryParams.companiesIds[0]),
        );

        if (stockItem) {
          return stockItem.stock;
        }

        return '-';
      },
      width: 180,
      align: 'right',
    },
    {
      title: intl({ id: 'parts.consultation.application.salePrice' }),
      dataIndex: 'prices',
      key: 'salePrice',
      render(_, row) {
        const priceItem = row.prices.find(
          (item) =>
            queryParams.companiesIds?.length &&
            item.company.id === Number(queryParams.companiesIds[0]),
        );

        if (priceItem) {
          return formatterPrice(priceItem.price);
        }

        return '-';
      },
      width: 180,
      align: 'right',
    },

    {
      key: 'actions',
      render: (_, record) => (
        <DetailsButton
          onClick={() =>
            history.push(`/app/searchParts/${record.partId}/stock`)
          }
        >
          {intl({ id: 'parts.consultation.application.btn.select' })}
        </DetailsButton>
      ),
      width: 110,
      fixed: 'right',
      align: 'right',
    },
  ];

  return (
    <>
      <Form>
        <Row style={{ marginBottom: 24 }}>
          <Col span={24} md={12} lg={6}>
            <FloatingFormItem label="Empresa" name="companyIds">
              <CompaniesInfiniteSelectField
                queryEnable
                selectFirst
                value={
                  queryParams?.companiesIds?.length
                    ? queryParams?.companiesIds[0]
                    : undefined
                }
                onChange={(values) => {
                  setQueryParams((prev) => ({
                    ...prev,
                    companiesIds: [values],
                  }));
                }}
              />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>

      <InfiniteTable<StockItem>
        dataSource={stockItems}
        columns={columns}
        loading={stockItemsList.isFetching}
        scroll={{ x: getTableScrollX(columns) }}
        fetchNextPage={stockItemsList.fetchNextPage}
        hasNextPage={stockItemsList.hasNextPage}
      />
    </>
  );
};

export default SearchPartReplacementTable;
